/**
 * HomeAppSection — 내 계정 › 기기관리 맨 위 "홈 화면 앱" 줄(모바일에서만).
 *  · 홈 화면 앱으로 보는 중 → "설치됨 · 이 기기" 배지
 *  · 안내 가능한 브라우저(iOS Safari · Android Chrome 계열) → [추가] = 설치 안내 모달 다시 열기
 *  · 그 밖의 모바일 브라우저(카카오톡·네이버 앱 등) → 기본 브라우저로 열라는 안내
 * PC 에서는 해당이 없어 아무것도 그리지 않는다(DESIGN: 해당 없는 컨트롤은 숨김).
 */
import { Icon } from "@/components/ui/Icon";
import { openA2hsGuide } from "@/hooks/useA2hsGuide";
import { a2hsPlatformOf } from "@/domain/a2hs";
import { detectDeviceKind, isStandaloneApp } from "@/domain/device_info";
import { A2HS_APP_ICON } from "./A2hsDemo";
import "./a2hs.css";

export function HomeAppSection() {
  if (typeof navigator === "undefined") return null;
  const env = { userAgent: navigator.userAgent, maxTouchPoints: navigator.maxTouchPoints };
  if (detectDeviceKind(env) !== "mo") return null;
  const standalone = isStandaloneApp();
  const platform = a2hsPlatformOf({ ...env, standalone });

  return (
    <section className="ma-sec">
      <h3 className="ma-sec-title">홈 화면 앱</h3>
      <div className="ma-card ma-ntf-device">
        <div className="ma-inline" style={{ flexWrap: "nowrap", minWidth: 0 }}>
          <img src={A2HS_APP_ICON} alt="" style={{ width: 40, height: 40, borderRadius: "var(--r-md)", flexShrink: 0 }} />
          <div className="ma-ntf-text">
            <div className="ma-ntf-label">
              {standalone ? "홈 화면 앱" : "홈 화면에 추가"}
              {standalone && <span className="badge badge-ok"><Icon name="check" size={12} /> 설치됨 · 이 기기</span>}
            </div>
            <div className="ma-help">
              {standalone
                ? "지금 홈 화면 앱으로 보고 있습니다"
                : platform
                  ? "이 기기에는 아직 추가 안 됨 · 주소창 없이 앱처럼 열립니다"
                  : "카카오톡·네이버 앱 안에서는 추가할 수 없습니다. Safari 나 Chrome 으로 열어 주세요"}
            </div>
          </div>
        </div>
        {!standalone && platform && (
          <button type="button" className="btn-primary" onClick={openA2hsGuide}>
            추가
          </button>
        )}
      </div>
    </section>
  );
}
